<template>
  <hypto-popup title="Add Funds to Hypto Account" :footer="false" css="width-lg">
    <template v-slot:body>
      <div class="add-funds">
        <h6>Fund using Online Transfer / UPI</h6>
        <p class="top">You can fund your account by transferring the amount to your Hypto Account</p>

        <h5>Account Details:</h5>
        <show-accounts :accountDetails="accountDetails" />

        <p>If the money is transferred through IMPS/UPI, the amount will be reflected in your Hypto account within 10 mins.</p>
        <p>If the money is transferred through NEFT/RTGS, the amount will be reflected in your Hypto Account within 3 working hours.</p>
      </div>
    </template>
  </hypto-popup>
</template>

<script>
import ShowAccounts from '@/components/AccountSummary/ShowAccounts'
import HyptoPopup from '@/components/global/HyptoPopup'

export default {
  name: 'AddFunds',
  components: { HyptoPopup, ShowAccounts },
  props: {
    accountDetails: Array
  }
}
</script>

<style lang="scss" scoped>
  @import '@/assets/scss/mixins.scss';

  .add-funds {
    text-align: left;

    h6 {
      @include normal-text($secondary, 16px, 500);
    }
    p {
      @include normal-text($grey-text, 14px, normal);

      &.top {
        margin: 10px 0 20px;
      }
      &:not(.top) {
        margin: 10px 0;
      }
    }

    h5 {
      @include highlight-text($grey-text, 15px, 700);
      margin-bottom: 5px;
    }

    .show-accounts {
      border: 1px solid $grey-outline;
      border-radius: 15px;
      padding: 15px;
      background: #F4F6F6;
      margin-bottom: 30px;
    }
  }
</style>
